// Rapier, loaded without wasm-bindgen's FinalizationRegistry (§14 GC budget). Every temporary the
// Rapier JS API creates (query inputs and results, pose vectors, forces) is freed explicitly with
// .free(), so registering each one for finalization only adds garbage-collector work: ~10,000
// registrations per second at 240 Hz, which showed up as 2–4 ms GC pauses. Long-lived objects (the
// world, bodies, colliders) live until World.free(). tests/determinism.test.ts checks that the
// wasm heap does not grow over a long run. Import order matters: hide → Rapier → restore.
import './hide-finalizers';
import RAPIER from '@dimforge/rapier3d-compat';
import './restore-finalizers';

export default RAPIER;
